const sendExtoleRegistrationEvent = ({ nodeEnv, primaryActorId, actorId, loanId, email, firstName, lastName }) => {
  const data = {
    primaryActorId,
    loanAppActorId: actorId,
    loanId,
    email,
    first_name: firstName,
    last_name: lastName,
    labels: 'personal',
  };

  // set 'container' property to 'test' for demo/stage environments, omit for production
  if (!/^prod/.test(nodeEnv)) data.container = 'test';

  const extole = window.extole;

  // Log Heap event
  if (window.lcTracking) {
    const hasCreateZoneFunction = extole && typeof extole.createZone === 'function';
    window.lcTracking.trackCustomEvent({
      eventName: 'Extole - PL Funnel Registration',
      ACTION: 'Sending registration event to Extole',
      AID: actorId,
      hasCreateZoneFunction,
    });
  }

  extole &&
    extole.createZone({
      name: 'registration',
      data,
    });
};

export default sendExtoleRegistrationEvent;

